/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".criteria-box[_ngcontent-%COMP%] {\n  background-color: white;\n  border-radius: 1em; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/report/report.component.scss.shim.ngstyle.js.pre-build-optimizer.js